import * as React from "react";
import {
  Box,
  Grid,
  IconButton,
  InputBase,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Formik } from "formik";
import { useMutation, useQuery } from "react-query";
import { CreateNewPaymentSettlementRequest } from "../../models/supplierPayment.model";
import { ToastContainer, toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import {
  Container,
  Paper,
  ThemeProvider,
  makeStyles,
  createStyles,
  Theme,
} from "@material-ui/core";
import SearchIcon from "@mui/icons-material/Search";
import Fuse from "fuse.js";
import { GetStatusResponse } from "../../models/basicInformation.model";
import { GetSuppliers } from "../../services/basicInformation.service";
import { addSupplierToLoanTemplate } from "../../services/loanTemplate.service";
import { AddSupplierToLoanTemplateRequest } from "../../models/loanTemplate.model";
import { v4 as uuid } from "uuid";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
let muiSelected: any;

export default function ModalNotification({
  openModel,
  setSendConfirmation,
  setOpenVerifyModal,
  loanTemplateId,
  setFlagModal,
}: any) {
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.muiSelected;

  const [open, setOpen] = React.useState<boolean>(openModel);
  const classes = useStyles();
  const [supplierId, setSupplierId] = React.useState();
  const [data, setData] = React.useState<GetStatusResponse[]>([]);
  const [searchTerm, setSearchTerm] = React.useState("");

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value.trim().toLocaleLowerCase());
  };

  const fuse = new Fuse(data, {
    keys: ["title"],
    includeScore: true,
    threshold: 0.1,
    ignoreLocation: true,
    useExtendedSearch: true,
  });
  const results = fuse.search(searchTerm);
  const titleResults = searchTerm ? results.map((title) => title.item) : data;
  const [selectedRow, setSelectedRow] = React.useState(undefined);
  const handleSelectRow = (rowIndex: any, value: any) => {
    setSelectedRow(rowIndex);
    setSupplierId(value.id);
  };

  const handleClose = () => {
    setOpen(false);
    setSendConfirmation(false);
    setOpenVerifyModal(false);
  };
  React.useEffect(() => {
    setOpen(openModel);
    getSupplier.mutate();
  }, [openModel]);

  const getSupplier = useMutation(GetSuppliers, {
    onSuccess(data: GetStatusResponse[]) {
      setData(data);
    },
  });

  function handleAddSupplier() {
    let addSupplier = {} as AddSupplierToLoanTemplateRequest;
    addSupplier.supplierId = supplierId!;
    addSupplier.loanTemplateId = loanTemplateId;
    addSupplierToLoanTemplateMutation.mutate(addSupplier);
    setSendConfirmation(false);
    setOpen(false);
    setOpenVerifyModal(false);
    setSearchTerm("");
    setFlagModal(uuid());
  }

  const addSupplierToLoanTemplateMutation = useMutation(
    addSupplierToLoanTemplate,
    {
      onSuccess: (result: boolean) => {
        if (result) {
          toast.success(" عملیات با موفقیت انجام شد.");
          // history.push("SettlementWithReceiver");
        }
      },
    }
  );

  const backClick = () => {
    handleClose();
  };

  let initialValues = new CreateNewPaymentSettlementRequest();

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {}}
          validateOnMount={true}
          // validationSchema={userCreditAmountSchema}
        >
          {({
            handleSubmit,
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
          }) => (
            <form onSubmit={handleSubmit}>
              <>
                <Grid>
                  <Box
                    sx={style}
                    style={{
                      borderRadius: "6px",
                      padding: "2px 40px 40px 40px",
                      marginTop: "67px",
                    }}
                    className="NotificationModalCmp  "
                  >
                    <span
                      style={{
                        color: "#1D4A87",
                        fontSize: "16px",
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "grid",
                        marginTop: "48px",
                        marginBottom: "22px",
                      }}
                    >
                      اتصال پذیرنده به طرح
                    </span>
                    <Grid container xs={12}>
                      <Grid item xs={12}>
                        <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                          <Paper
                            elevation={0}
                            style={{
                              border: "1px solid #DAE0E4",
                              display: "flex",
                            }}
                            className="boxShadow"
                            square={false}
                          >
                            <InputBase
                              sx={{ ml: 1, flex: 1, paddingX: "16px" }}
                              placeholder="جستجو پذیرنده"
                              // inputProps={{ 'aria-label': 'جستجو' }}
                              onChange={handleSearchInput}
                            />
                            <IconButton
                              type="button"
                              sx={{ color: "#9AAFC4" }}
                              aria-label="search"
                            >
                              <SearchIcon />
                            </IconButton>
                          </Paper>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{ paddingTop: "20px", direction: "ltr" }}
                      >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <TableContainer
                            style={{
                              background: "#fff",
                              maxHeight: "40vh",
                              height: "auto",
                            }}
                            className="notificationScroll"
                          >
                            <Table
                              stickyHeader
                              aria-label="sticky table"
                              style={{
                                borderCollapse: "collapse",
                                border: "solid 1px #DAE0E4",
                              }}
                            >
                              <TableBody>
                                {titleResults.map(
                                  (item: any, index: number) => (
                                    // data
                                    //     ? data.map((row, rowIndex) =>
                                    //     {
                                    //         return (
                                    <TableRow
                                      selected={selectedRow === index + 1}
                                      onClick={() =>
                                        handleSelectRow(index + 1, item)
                                      }
                                      classes={{ root: classes.select }}
                                      // className={`${
                                      //   rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                                      // } ${classes} borderRight borderLeft cursorPointer noWrap`}
                                      hover
                                      role="checkbox"
                                      tabIndex={-1}
                                      // style={{ text- align - last: right;}}
                                      // key={row.loanRequestId}
                                      // selected={selectedRow === rowIndex}
                                      // onClick={() => handleDetail(row.key!)}
                                    >
                                      <TableCell
                                        className="textFont12"
                                        // key={column.id}
                                        align="right"
                                      >
                                        {item.title}
                                        {/* {column.format && column.hasFormat
                                                                                        ? column.format(value)
                                                                                        : value?.toString()} */}
                                      </TableCell>
                                      {/* );
                                                                                    })} */}
                                    </TableRow>
                                    //     );
                                    // })
                                    // : null
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Grid>
                      <Grid container xs={12} style={{ paddingTop: "5vh" }}>
                        <Grid item xs={4}></Grid>
                        <Grid container xs={8}>
                          <Grid
                            item
                            xs={6}
                            style={{
                              textAlign: "end",
                              left: "-32px",
                              position: "relative",
                            }}
                          >
                            <Button
                              type="submit"
                              disabled={supplierId ? false : true}
                              className={
                                supplierId
                                  ? "btnForm SuccessDefault "
                                  : "btnForm disabledBtn  "
                              }
                              onClick={handleAddSupplier}
                              // className={"btnForm SuccessDefault "}
                              style={{ width: "120px", marginLeft: "1vh" }}
                            >
                              افزودن پذیرنده
                            </Button>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            style={{
                              left: "29px",
                              position: "absolute",
                              textAlign: "end",
                            }}
                          >
                            <Button
                              className="btnForm ComingBack"
                              style={{
                                width: "120px",
                                marginLeft: "1vh",
                                textAlign: "left",
                              }}
                              onClick={backClick}
                            >
                              بازگشت
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </>
            </form>
          )}
        </Formik>
      </Modal>
    </div>
  );
}
